export const LINKS = {
  calendly: "https://calendly.com/thestrengthmovementt/30min",
  liftingGuide: "https://thestrengthmovement.myflodesk.com/maxliftingguide",
  foodFreedomGuide: "https://thestrengthmovement.myflodesk.com/tsmfoodfreedomguide",
  emailList: "https://thestrengthmovement.myflodesk.com/wfgs7i9ayt",
  instagram: "https://www.instagram.com/the_strength.movement/",
  podcast:
    "https://open.spotify.com/show/2sgfEqg2q9kOZqmR9xVw1d?si=36b8bcb94f864c5b",
};

const SS =
  "https://images.squarespace-cdn.com/content/v1/634e7b69912eb5213ba86922";

export const IMAGES = {
  hero: `${SS}/70d4a6d8-5bc9-4730-a660-a89bfea3ee73/Emma+Veness+Photography-18.jpg`,
  kimPortrait: `${SS}/d0f02918-c7c1-4ecc-ab21-8ff844c5900e/The+Strength+Movement+-+Coach+Kim.png`,
  kimFlip: `${SS}/a3b0e709-3093-4f54-9a5f-fa0e8612878e/The+Strength+Movement+-+Coach+Kim+-+Flip.png`,
  kimWeights: `${SS}/b3dd5fa5-fe00-49e4-82ed-30be2505dc96/Coach+Kim+-+The+Strength+Movement+-+Weights.png`,
  coaching: `${SS}/2fa8bad3-c2d6-4ba1-a11f-cb3f7ba6d757/Emma+Veness+Photography-143.jpg`,
  clientLift: `${SS}/e9069d77-5531-46f8-92bb-d559d1fdebe4/MFP_x_In2Performance-129+2.png`,
  clientTori: `${SS}/010c1ec0-65fa-4f54-9a5f-fa0e8612878e/MFP_x_In2Performance-129+2.JPG`,
  clientCaitlin: `${SS}/100c6bea-965c-425b-8d37-6a090e46b698/B0E00FA9-060E-4AAB-AA6F-4108E4E5CC94.JPG`,
  clientEmily: `${SS}/2005a00e-1b22-4227-81e6-01e8653ec5e9/IMG_4779.jpg`,
  kimEveryday: `${SS}/adad798d-4a29-4b70-a206-c3355d759ef6/IMG_0625.jpeg`,
  nature:
    "https://images.unsplash.com/photo-1683669446899-b52d1c6b12dc?q=80&w=1600&auto=format&fit=crop",
  squadSquat: "/images/community/c2.jpg",
  crewClap: "/images/community/c3.jpg",
  foodFreedom: "/images/community/food-freedom.webp",
  crewGroup: "/images/community/mentorship-crew.webp",
};

export const TESTIMONIALS = [
  {
    name: "Tori",
    tag: "Strength & powerlifting",
    quote:
      "Kim and I have been working together since the start of 2023 and she has taken my Squat from 40kg to 105kg, my Deadlift 70kg to 130kg and Bench 25kg to 55kg. My technique feels stronger than ever before and I love that I can record this all in our app which she continuously works with me to customise.",
  },
  {
    name: "Caitlin",
    tag: "Mindset & food relationship",
    quote:
      "Kim has helped me shift my mentality from being very weight focused, to how I FEEL and trusting that fat reduction will be a natural byproduct of the work being put in. What I've learned will continue to improve my quality of life for years to come.",
  },
  {
    name: "Emily",
    tag: "Confidence under the bar",
    quote:
      "Before I started training, I wanted to become stronger but was really anxious about the idea. Kim has made me feel so much more confident and capable in myself. I've hit powerlifting PRs I never thought I'd reach, and it's all thanks to her guidance and support.",
  },
  {
    name: "Smilla",
    tag: "In one session",
    quote:
      "I've been training for 10 years and no one has really looked at my form as holistically as Kim!! I was so surprised I was able to instantly squat lower with no pain!! She gave me super specific feedback and tailored her approach to what worked for my body.",
  },
];

export const PAIN_POINTS = [
  "You've been lifting for a while, but progress feels inconsistent.",
  "You're stronger than before, yet you still don't fully trust your body.",
  "You keep wondering if you're eating enough, too much, or the “right” foods.",
  "Every fitness expert online seems to say something different.",
  "You want strength that actually improves your life, not just your numbers.",
];

export const SERVICES = [
  {
    id: "build",
    number: "01",
    name: "Build Coaching",
    audience: "For women",
    tagline: "Strength, confidence and performance, without the second-guessing.",
    description:
      "1:1 coaching for women who want to perform stronger than ever in the gym, know what their body needs in any scenario without guilt, and learn what their unique body needs, through both science and psychology.",
    image: "squadSquat",
  },
  {
    id: "food-freedom",
    number: "02",
    name: "Food Freedom Coaching",
    audience: "For women",
    tagline: "A peaceful relationship with food and your body.",
    description:
      "Food isn't the problem. Together we work through the science, hunger, hormones, fuelling performance, and the psychology, food rules, body image and self-trust, so eating stops feeling like a battle.",
    image: "foodFreedom",
  },
  {
    id: "mentorship",
    number: "03",
    name: "PT Mentorship",
    audience: "For coaches",
    tagline: "Because knowing the textbook isn't the same as coaching a human.",
    description:
      "For PT students and developing coaches: programming and movement, yes, but also communication, psychology, food and body image conversations, and the judgement to coach the individual in front of you.",
    image: "crewGroup",
  },
];

export const BUILD_INCLUDES = [
  {
    title: "Personalised programming",
    text: "Updated every 4-6 weeks based on your progress, inside The Strength Movement app.",
  },
  {
    title: "Weekly check-ins",
    text: "To pave direction into the next week, you're never left guessing.",
  },
  {
    title: "Messaging & technique feedback",
    text: "Progressions, video feedback and ongoing messaging around everything we're working on.",
  },
  {
    title: "Nutrition support",
    text: "Whether it's a more peaceful relationship with food or fuelling your goals, guided in a way that works for you. No overwhelm.",
  },
  {
    title: "Resources & recordings",
    text: "An intro pamphlet and everything you can expect across your first 12 weeks.",
  },
  {
    title: "Group sessions & catch ups",
    text: "Because we love connecting with likeminded women growing in this space.",
  },
];

export const FAQS = [
  {
    q: "Do I need powerlifting experience?",
    a: "Not at all. Build Coaching meets you where you are, whether you've never touched a barbell or you've been training for years. Your program is built around your body, your experience and your goals.",
  },
  {
    q: "What if I struggle with food?",
    a: "You're in the right place. Nutrition support is woven through everything we do, from building a more peaceful relationship with food to learning how to fuel your training. No guilt, no overwhelm.",
  },
  {
    q: "What if I can only train three days a week?",
    a: "Your programming is personalised to your schedule. Three well-built days beats six chaotic ones, we build around your real life, not an idealised one.",
  },
  {
    q: "Is coaching online or in person?",
    a: "Build Coaching is fully online through The Strength Movement app, with weekly check-ins and messaging. If you're local, you can add in-person PT sessions, fortnightly or weekly.",
  },
  {
    q: "How do I get started?",
    a: "Book a free 30-minute chat with Kim. We'll talk about where you're at, what you're looking for, and whether coaching is the right fit, no pressure either way.",
  },
];

export const NAV_LINKS = [
  { to: "/science", label: "The Science" },
  { to: "/psychology", label: "The Psychology" },
  { to: "/coaching", label: "Coaching" },
  { to: "/mentorship", label: "PT Movement Mentorship" },
  { to: "/about", label: "About Me" },
];
